import { render } from "./App.vue?vue&type=template&id=4ef3839c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4ef3839c&lang=css"

import exportComponent from "D:\\Java Script Udemy Kurs\\VUE COURSE\\music_player\\music_player_sj\\music_player\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__